/**
 * @fileoverview CategoryReportPage - Category and date range search page.
 *
 * Page for searching and reporting on transactions by category within a date range.
 *
 * @description This page component:
 * - Allows filtering transactions by specific category
 * - Supports date range filtering (inclusive)
 * - Shows summary statistics broken down by transaction type
 * - Displays filtered transaction list with searched category highlighted
 *
 * Component composition:
 * - BackButton: Return to main page
 * - CategoryReport: Main report component with filters and results
 *
 * @module pages/CategoryReportPage
 */
import CategoryReport from '../components/Reports/CategoryReport';
import BackButton from '../components/shared/BackButton';
import styles from './ReportPage.module.css';

/**
 * Category search and report page.
 *
 * @param {Object} props - Component props
 * @param {Object} props.transactionHook - Transaction hook with all transaction data
 * @param {Object} props.categoryHook - Category hook for category information
 * @param {Object} props.budgetInfo - Budget metadata including start month
 * @param {Function} props.onBack - Navigate back handler
 */
function CategoryReportPage({
  transactionHook,
  categoryHook,
  budgetInfo,
  onBack
}) {
  return (
    <div className={styles.container}>
      <BackButton onClick={onBack} />
      <h1 className={styles.pageTitle}>Category Search</h1>

      <CategoryReport
        transactionHook={transactionHook}
        categoryHook={categoryHook}
        budgetInfo={budgetInfo}
      />
    </div>
  );
}

export default CategoryReportPage;
